import { put } from 'redux-saga/effects';
import { apiEndPoints } from '../../../services/axios/endPoints';
import { WebService } from '../../../services/axios/webServices';
import { Creators } from './action';
import { sagaCatchBlockHandling } from '../../../store/utility/sagaErrorHandling';

export function* getProfileListSaga({ payload }) {
  const { page, pageSize, searchParams } = payload;

  try {
    yield put(Creators.getProfileListStart());
    const response = yield WebService.post(
      `${apiEndPoints?.getProfileList}/${page || 1}/${pageSize || 10}`,
      {
        SearchFilters: { ...searchParams }
      }
    );
    if (response.status >= 200 && response.status < 300) {
      const { data, meta, Count, CanEdit, CanAdd } = response.data;
      const profilePermissions = { CanEdit, CanAdd };
      yield put(
        Creators.getProfileListSuccess({
          data,
          meta,
          Count,
          profilePermissions
        })
      );
    } else {
      throw response;
    }
  } catch (error) {
    const { error: err } = sagaCatchBlockHandling(error);
    yield put(Creators.getProfileListFailure(err));
  }
}
